<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OoNRZc/tc-custom/9781625675408.jpg?1726444246422" alt="This image is the cover for the book Bottle Demon, Eric Carter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Bottle Demon, Eric Carter
      </h1>
      <p class="bookDescription body article font2">
        <b>Stephen Blackmoore's dark urban fantasy series continues as hard-edged, hard-hitting necromancer Eric Carter finds himself surrounded by enemies who want him to suffer a fate worse than death… by bringing him back to life.</b><br/><br/>When Carter comes to, he feels like Hell. Worse than hell. Every part of his body is on fire, his stomach is boiling acid, and he’s coughing up some horrific black substance from his lungs. He’s not feeling—or looking—like himself. All in all, not a jolly start to the day.<br/><br/>Unfortunately, that’s about as good as its going to get. Because, as he soon learns, he’s been dead for years—until someone with some serious magical muscle decided to bring him back. But who could Carter have ticked off so badly they would expend such power just to return him to the mortal realm?<br/><br/>Oh, that’s right: raging gods, sadistic demons, a very patient and vengeful djinn… pretty much every nightmare in the monster’s menagerie. And if Carter doesn’t figure out why someone—or some thing—is pulling the strings, his new life may have an even more gruesome end than his old one.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Blackmoore
      </h2>
      
      <p class="authorDescription body article">Stephen Blackmoore is the Los Angeles-based author of the noir/urban fantasy Eric Carter series, including <i>Dead Things</i>, <i>Broken Souls</i>, <i>Hungry Ghosts</i>, <i>Fire Season</i>, <i>Ghost Money</i>, <i>Bottle Demon</i>, and the stand-alone <i>City Of The Lost</i>. He has written tie-in novels for the role-playing game Spirit of The Century (<i>Khan of Mars</i>), the video-game Wasteland 2 (<i>All Bad Things</i>) and the television series Heroes Reborn (<i>Dirty Deeds</i>), as well as part of the Gods and Monster series (<i>Mythbreaker</i>). His short stories can be found at <i>Fireside Fiction</i>, <i>Plots With Guns</i>, and in anthologies such as <i>Urban Allies</i>, <i>Deadly Treats</i>, <i>Don't Read this Book</i>, <i>Uncage Me</i> and many others.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      JABberwocky Literary Agency, Inc
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?466b5c64